import { CSSProperties, PropsWithChildren } from 'react'
import { calendarEventBackground } from '@pogokid/util'
import styles from './Scheduler.module.css'
import { useHotkeys } from 'react-hotkeys-hook'
import {
  useSchedulerDispatchContext,
  useSchedulerPropsContext,
} from '../../context/schedulerContext.ts'

export function Scheduler({ children }: PropsWithChildren) {
  const { calendarColours } = useSchedulerPropsContext()
  const { closeDialog } = useSchedulerDispatchContext()

  useHotkeys(['esc'], () => {
    closeDialog()
  })

  const cssVars: CSSProperties = calendarColours
    .entries()
    .reduce((vars, [calendarId, colour]) => {
      return {
        ...vars,
        [`--Scheduler-calendar-${calendarId}-colour`]:
          calendarEventBackground(colour),
      }
    }, {} as CSSProperties)

  return (
    <div className={styles.Scheduler} style={cssVars}>
      {children}
    </div>
  )
}
